module.exports = __webpack_public_path__ + "img/gb-wave-1.284515c3.webp";